module.exports = __webpack_public_path__ + "static/media/logo.f44ae72a.svg";